import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { strings } from "../../Common/String";
import Count from "../../Component/CountComponent/Count";
import { Checkbox } from "../../Component/Form/Checkbox";
import { Input } from "../../Component/Form/Input";
import { yupResolver } from "@hookform/resolvers/yup";
import { bool, object, string } from "yup";
import { Form } from "../../Component/Form";
import { Dropdown } from "../../Component/Form/Dropdown";
import { LeadService } from "../../Services/LeadService";
import { AppContext } from "../../Context/AppContext";
import AlertBox from "../../Component/AlertBox";
import { OTP_TYPES } from "../../Common/Constants";
import IconButton from "../../Common/IconButton";
import Button from "../../Component/Button";
import { SummaryContext } from "../Summary/context";
import { isEmpty } from "lodash";

const Mobile = (props) => {
  const { show, cancelButtonAction, onSuccess } = props;
  const { setLoading } = useContext(AppContext);
  const { masterRelationships: ddRelationship } = useContext(SummaryContext);

  const [showOTPBlock, setShowOTPBlock] = useState(false);
  const [restartTimer, setRestartTimer] = useState(0);
  const [isShow, setShow] = useState(false);
  const [showPencil, setShowPencil] = useState(false);
  const [showRelation, setShowRelation] = useState(false);
  const [apiMessage, setApiMessage] = useState(undefined);

  const phoneRef = useRef();
  const otpRef = useRef();

  const defOption = useMemo(
    () => ddRelationship.find((d) => d.is_default === true),
    [ddRelationship]
  );

  const schema = object().shape({
    mobile: string()
      .required(strings.rekyc_mobile_error)
      // .min(10, strings.rekyc_mobile_error)
      .max(10, strings.rekyc_mobile_error),
    tnc: bool().test("required", strings.rekyc_chkerror, (value) => {
      return !showOTPBlock ? value : true;
    }),
    otp: string()
      .test("required", strings.rekyc_otp_error, (value) => {
        return showOTPBlock ? value && !isNaN(value) : true;
      })
      // .min(showOTPBlock ? 6 : 0, strings.rekyc_otp_error)
      .max(6, strings.rekyc_otp_error),
    relationship: string().test(strings.rekyc_error, (value) => {
      return showRelation ? value : true;
    }),
  });

  const resolver = yupResolver(schema);

  const registerForm = useForm({
    defaultValues: {
      mobile: "",
      tnc: false,
      otp: "",
      relationship: "",
    },
    // reValidateMode: undefined,
    resolver,
  });

  useEffect(() => {
    if (defOption) {
      registerForm.setValue(
        "relationship",
        defOption?.value || ddRelationship[0].value
      );
    }
  }, [defOption]);

  useEffect(() => {
    if (show && phoneRef && phoneRef.current) phoneRef.current.focus();
  }, [show]);

  const requestOTP = (data) => {
    setLoading(true);
    LeadService.rekycSectionRequestOTP(OTP_TYPES.SMS, data.mobile)
      .then((data) => {
        if (data.success) {
          setShowOTPBlock(true);
          setShow(true);
          if (otpRef && otpRef.current) otpRef.current.focus();
          setRestartTimer((old) => old + 1);
          setShowRelation(data.relationship_required);
          setApiMessage(undefined);
        } else {
          setApiMessage(data.error);
          console.error(data.error);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => setLoading(false));
  };

  const onSubmit = (data) => {
    setLoading(true);
    LeadService.rekycSectionValidateOTP(
      OTP_TYPES.SMS,
      data.mobile,
      data.otp,
      data.relationship
    )
      .then((data) => {
        if (data.success) {
          resetForm();
          onSuccess();
        } else {
          setApiMessage(data.error);
          console.error(data.error);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => setLoading(false));
  };

  const resetForm = () => {
    const checkbox = document.getElementById("mobile-tnc");
    if (checkbox) checkbox.checked = false;
    registerForm.reset({
      mobile: "",
      tnc: false,
      otp: "",
      relationship: defOption?.value,
    });
    setShowOTPBlock(false);
    setShowPencil(false);
    setShow(false);
    setShowRelation(false);
    setApiMessage(undefined);
  };

  const onCancel = () => {
    resetForm();
    cancelButtonAction();
  };

  const resendOTP = () => {
    setShowPencil(false);
    requestOTP(registerForm.getValues());
  };

  const editpencil = (event) => {
    event.preventDefault();
    setShowOTPBlock(false);
    setShow(false);
    setShowRelation(false);
    setApiMessage(undefined);
    registerForm.resetField("otp");
  };

  const ApiError = () =>
    !isEmpty(apiMessage) ? (
      <div className="text-danger errorfont text-center">
        <label id="txterror" name="txterror">
          {apiMessage}
        </label>{" "}
      </div>
    ) : null;

  return (
    <div className="loaderContainers">
      <AlertBox
        show={show}
        title={
          <div className="ml-4 mt-3 w-75">
            <h5 className="update-label">{strings.rekyc_update_label}</h5>
          </div>
        }
        showCancelIcon={true}
        cancelButtonAction={onCancel}
        classes="box-sections"
      >
        <div className="container" id="pd-50">
          <hr />
          <Form
            autoFocusElement="mobile"
            reactHookForm={registerForm}
            onSubmit={showOTPBlock ? onSubmit : requestOTP}
          >
            <Input
              reference={phoneRef}
              classes="inp pt-3"
              tabIndex="81"
              placeholder={strings.rekyc_mobile_label}
              inputClass="mobinput"
              type="number"
              name="mobile"
              maxLength={10}
              pattern="\d*"
              disabled={isShow}
              errorclass="text-danger err"
              prefix={<label className="ind">+91</label>}
              postfix={
                isShow && (
                  <IconButton
                    classes={"edit-bt"}
                    imgsrc={process.env.PUBLIC_URL + "/img/pen.png"}
                    click={editpencil}
                  />
                )
              }
            />
            {!showOTPBlock ? (
              <>
                <Checkbox
                  type="checkbox"
                  classes="check1 mt-2"
                  inputClass="check2 mt-0"
                  name="tnc"
                  id="mobile-tnc"
                  tabIndex="82"
                  label={strings.rekyc_mobilepara_label}
                  labelClass="lblcheck mb-0 -mt-2"
                  errorclass="text-danger errs"
                />
                <ApiError />
                <div className="pt-3 row justify-content-end align-items-center mr-0">
                  <Button
                    type="reset"
                    classes1="cancelbtn"
                    click={onCancel}
                    label="Cancel"
                  />
                  <Button
                    type="submit"
                    classes1="inps"
                    tabIndex="83"
                    label="Send OTP"
                  />
                </div>
              </>
            ) : (
              <>
                <Input
                  reference={otpRef}
                  placeholder="Enter OTP"
                  inputClass="mobinputs"
                  type="number"
                  name="otp"
                  tabIndex="82"
                  pattern="\d*"
                  maxLength={6}
                  errorclass="text-danger errorfont mh-18"
                  postfix={
                    <div className="otp-timer">
                      <Count
                        onFinish={() => setShowPencil(true)}
                        restart={restartTimer}
                      />
                    </div>
                  }
                />
                {showPencil && (
                  <p className="resends p1-2">
                    Didn't Receive OTP?{" "}
                    <a href="#" onClick={resendOTP}>
                      Resend
                    </a>
                  </p>
                )}
                {showRelation ? (
                  <Dropdown
                    classes="material-textfield mt-2"
                    label={strings.rekyc_relation_label}
                    labelClass="lbltransforms lblz"
                    selectClass="mobinputs pb-2 p-2"
                    drId="inc"
                    tabIndex="83"
                    selectid="ddl_inc"
                    name="relationship"
                    options={ddRelationship}
                    errorclass="text-danger errorfont mh-18"
                  />
                ) : null}
                <ApiError />
                <Button
                  type="submit"
                  classes1="inpt"
                  tabIndex="84"
                  label="Submit"
                />
              </>
            )}
          </Form>
        </div>
      </AlertBox>
    </div>
  );
};

export { Mobile };
